export default "__VITE_ASSET__cnLkgesT__"